<template>
    <div>
    </div>
</template>

<script>
export default {
    name: "ExampleComponent",
    data: () => ({

    }),
};
</script>

<style scoped>
</style>
